// Tabs component override
export default function Tabs() {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTabs-indicator': {
            height: '3px',
            borderRadius: '3px 3px 0 0'
          }
        }
      }
    }
  };
}
